import React from "react"
import { Flex } from "@capioweb/ui-components"
import { ContentBase, Image } from "../../@types/CapioWeb/core"
import { StringProperty } from "../../@types/EpiFoundationSpa/Property"

interface MainCampaignBlockProps extends ContentBase {
	campaignDescription: StringProperty
	campaignHeading: StringProperty
	campaignLink: StringProperty
	campaignLinkText: StringProperty
	image: Image
}

const MainCampaignBlock: React.FC<MainCampaignBlockProps> = (props) => {
	return (
		<Flex
			w={1}
			h={10}
			justifyContent="center"
			alignItems="center"
			my={4}
			px={4}
		></Flex>
	)
}

export { MainCampaignBlock }
